import { render, staticRenderFns } from "./CandidateRemoveMijn.vue?vue&type=template&id=374166e4&lang=pug"
import script from "./CandidateRemoveMijn.vue?vue&type=script&lang=js"
export * from "./CandidateRemoveMijn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports